import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Rules from "./pages/Rules";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/guess-the-word">
      <Routes>
        <Route path="/" element={<Rules />} />
        <Route path="/play" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);